<div>
    <app-servico-lista
        [filtros]="filtros"
        (definirFiltro)="definirFiltro()"
        (exibir)="selecionar($event)">
    </app-servico-lista>
</div>